export default "__VITE_ASSET__DzB20qNZ__"